import React from 'react';
import styled from 'styled-components';

const RiskContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  width: 100px;
  text-align: center;
  height: 32px;
  flex-shrink: 0;
  background-color: ${props => {
    switch (props.riskLevel) {
      case 'Baixo':
        return '#bee1dd';
      case 'Médio':
        return '#c2d2e9';
      case 'Alto':
        return '#ffb2b2';
      default:
        return '#f3f4f6'; 
    }
  }};
  color: ${props => {
    switch (props.riskLevel) {
      case 'Baixo':
        return '#4fa569';
      case 'Médio':
        return '#677c9b'; 
      case 'Alto':
        return '#cd5252';
      default:
        return '#6b7280';
    }
  }};
  border: 1px solid ${props => {
    switch (props.riskLevel) {
      case 'Baixo':
        return '#4fa569';
      case 'Médio':
        return '#677c9b';
      case 'Alto':
        return '#cd5252';
      default:
        return '#e5e7eb';
    }
  }};
`;

const RiskLabel = styled.span`
  font-size: 8px;
  font-weight: 500;
  margin-bottom: 1px;
  opacity: 0.8;
  line-height: 1;
`;

const RiskValue = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
`;

const RiskMatrixLabel = ({ probability, impact, id }) => {
  // Calcula a matriz de risco
  const riskMatrix = probability * impact;
  
  // Determina o nível de risco
  let riskLevel = '';
  if (riskMatrix > 0 && riskMatrix <= 3) {
    riskLevel = 'Baixo';
  } else if (riskMatrix >= 4 && riskMatrix <= 6) {
    riskLevel = 'Médio';
  } else if (riskMatrix > 7) {
    riskLevel = 'Alto';
  }

  // Se não há dados de risco, não exibe nada
  if (!probability || !impact || probability === 0 || impact === 0) {
    return null;
  }

  return (
    <RiskContainer 
      id={`risk-matrix-${id}`}
      riskLevel={riskLevel}
    >
      <RiskLabel id={`risk-label-${id}`}>Risco</RiskLabel>
      <RiskValue id={`risk-value-${id}`}>{riskLevel}</RiskValue>
    </RiskContainer>
  );
};

export default RiskMatrixLabel;
